export default __webpack_public_path__ + "static/media/redtopurple.1051e682.jpg";